export default "__VITE_ASSET__CGPJv6fo__"